import React, { useState } from 'react';
import { FileUploader } from 'react-drag-drop-files';
import { Checkbox } from '@mui/material';
import { Images } from 'utils';
import { TextRow } from 'components';

const fileTypes = ['JPG', 'JPEG', 'PNG', 'WEBP'];

export const SignatureFileUploader = ({ onFileChange, onSaveAsDefaultChange, hideSaveDefault }) => {
    const [file, setFile] = useState('');
    const [saveAsDefault, setSaveAsDefault] = useState(false);

    const handleFile = (file) => {
        if (!file) return;
        setFile(file);
        onFileChange?.(file);
    };

    const clearFile = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setFile('');
        onFileChange?.(null);
    };

    const handleSaveAsDefaultChange = (e) => {
        setSaveAsDefault(e.target.checked);
        onSaveAsDefaultChange?.(e.target.checked);
    };

    return (
        <div>
            <div className="signature-upload-draw-box">
                <div className="canvas-wrapper">
                    <FileUploader handleChange={handleFile} name="file" types={fileTypes}>
                        <div
                            className="signature-file-uploader-box flex-align-center"
                            style={{ flexDirection: 'column', justifyContent: 'center' }}>
                            {file ? (
                                <div className="uploaded-signature-box">
                                    <img className="uploaded-signature-image" src={Images.signatureIcon} alt="icon" />
                                    <div className="full-width">
                                        <div className="full-width">
                                            <div className="space-between-align-start">
                                                <p className="uploaded-signature-name" style={{ width: '330px' }}>
                                                    <TextRow name={file?.name} />
                                                </p>
                                            </div>
                                        </div>
                                        <div className="flex-align-center uploaded-signature-information" style={{ margin: '4px 0' }}>
                                            <p>{file?.type?.replace('image/', '')}</p>
                                        </div>

                                        <div className="full-loaded">
                                            <div className="full-loaded-line" />
                                            <p>100%</p>
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <>
                                    <img src={Images.uploadCloudBlack} alt="icon" />
                                    <label className="custom-file-upload">
                                        <input
                                            onClick={(event) => (event.target.value = null)}
                                            onChange={(e) => handleFile(e.target.files?.[0])}
                                            type="file"
                                            id="file"
                                        />
                                        <i className="fa fa-cloud-upload" />
                                        <div className="upload">
                                            <p>
                                                Drag and drop OR Upload Signature
                                                <br /> (e.g., PNG or JPG max size 5MB.)
                                            </p>
                                        </div>
                                    </label>
                                </>
                            )}
                        </div>
                    </FileUploader>

                    <div className="canvas-line" />
                    <div className="type-signature-actions">
                        <div style={{ width: '25%' }} />
                        {!hideSaveDefault && (
                            <div className="type-signature-save-default" style={{ width: '50%' }}>
                                <Checkbox
                                    checked={saveAsDefault}
                                    onChange={handleSaveAsDefaultChange}
                                    style={{ padding: 0, color: saveAsDefault ? '#347AF0' : '#D0D5DD' }}
                                />
                                <span>Save as my default signature</span>
                            </div>
                        )}
                        {hideSaveDefault && <div style={{ width: '50%' }} />}
                        <div style={{ width: '25%', textAlign: 'end' }}>
                            {file && (
                                <button className="type-signature-clear-btn" onClick={clearFile}>
                                    Clear
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            {/*<p className="draw-info-text">By signing electronically, I agree to the clinic's terms and conditions.</p>*/}
        </div>
    );
};
